import { TrustMarkerType } from "@interfaces/trust-markers.types";

export interface TrustMarkerStyle {
  gradient: string;
  className: string;
}

export const TRUST_MARKER_STYLES: Record<string, TrustMarkerStyle> = {
  [TrustMarkerType.BEST_SELLER]: {
    gradient: "linear-gradient(180deg, #C09D5C 0%, #5B4C2F 100%)",
    className: "bestSeller",
  },
  [TrustMarkerType.NEWLY_LAUNCHED]: {
    gradient: "linear-gradient(180deg, #328674 0%, #27554B 100%)",
    className: "newlyLaunched",
  },
  [TrustMarkerType.MOST_VIEWED]: {
    gradient: "linear-gradient(180deg, #2B467F 0%, #162B58 100%)",
    className: "mostViewed",
  },
  [TrustMarkerType.MOST_SEARCHED]: {
    gradient: "linear-gradient(180deg, #7D65AA 0%, #483272 100%)",
    className: "mostSearched",
  },
};

export const getTrustMarkerStyleClass = (label: string): string => {
  const style = TRUST_MARKER_STYLES[label];
  return style ? style.className : "default";
};

